// Prevent multiple declarations when script is loaded multiple times
if (!customElements.get('video-item')) {

class VideoItem extends HTMLElement {
    constructor() {
        super();
        this._videoData = null;
        this.parseVideoData();
    }

    connectedCallback() {
        this.parseVideoData();
    }

    static get observedAttributes() {
        return ['video-inline'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'video-inline' && oldValue !== newValue) {
            this.parseVideoData();
        }
    }

    parseVideoData() {
        const json = this.getAttribute('video-inline');
        if (json) {
            try {
                this._videoData = JSON.parse(json);
            } catch (e) {
                console.error('Erreur de parsing de video-inline:', e);
                this._videoData = null;
            }
        } else {
            this._videoData = null;
        }
    }

    get videoData() {
        return this._videoData;
    }
}

customElements.define('video-item', VideoItem);

} // End of if (!customElements.get('video-item'))
